/**
 * @file routes/_app/audit/notices/route.tsx
 * @description 稽核通知 Layout 路由（M2）。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/audit/notices')({
  component: () => <Outlet />,
});
